import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import moment from 'moment';
import { Link, Redirect } from 'react-router-dom'
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import country_arr from './countries-arr.js';
import s_a from './states-arr.js';
import { setCookie, getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js";
import { useTheme } from "./theme-provider.js"
import PageError from '../common_component/PageError.js';
import { useHistory } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

function SubscriptionDeatails(props) {
	const [navtype, setnavtype] = useState("Billing_Address");

	const [duration, setDuration] = useState("mon");
	const [payment_mode, setpayment_mode] = useState("Non Recurring");
	const [price, setprice] = useState("");
	const [Currency_conversion_value, setCurrency_conversion_value] = useState(1);

	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)
	const [LiveCurrencyData, setLiveCurrencyData] = useState([]);
	const [WalletAmount, setWalletAmount] = useState("");

	const [expiry_date, setExpiryDate] = useState(new Date().toString());
	const [country_array, set_country_array] = useState([]);
	const [state_array, set_state_array] = useState([]);
	const [country, setcountry] = useState("");
	const [state1, setstate1] = useState("");
	const [GstIn, setGstIn] = useState("");
	const [phone, setphone] = useState("");
	const [name, setname] = useState("");
	const [pincode, setpincode] = useState("");
	const [city, setcity] = useState("");
	const [address_line1, setaddress_line1] = useState("");
	const [address_line2, setaddress_line2] = useState("");
	const [address_id, setaddress_id] = useState("");
	const [discounted_price, setdiscounted_price] = useState("");
	const [coupon_code, setcoupon_code] = useState("");
	const [referal_code, setreferal_code] = useState("");
	const [offerId, setOfferId] = useState("");
	const [discount_type, setdiscount_type] = useState("");
	const [discount_value, setdiscount_value] = useState(0);

	const [WalletModalShow, setWalletModalShow] = useState(false);
	const [addressModalShow, setAddressModalShow] = useState(false);
	const [discountModalShow, setDiscountModalShow] = useState(false);

	const [state, setstate] = useState(2);

	const [subscription, setSubscription] = useState([]);
	const [subscription_details, setsubscription_details] = useState([]);
	const [user_count, setuser_count] = useState(1);
	const [subscription_list, setsubscription_list] = useState([]);

	const [PaymentMethod, setPaymentMethod] = useState("Card");
	const [billing_address, setbilling_address] = useState([]);
	const [selected_billing_address, setselected_billing_address] = useState(null);
	const [apiState, setApiState] = useState(false);
	const [subscription_pattern, setsubscription_pattern] = useState("");
	const [Organization_admin, setOrganization_admin] = useState("");

	const [Add_on, setAdd_on] = useState("");
	const [Add_on1, setAdd_on1] = useState("");
	const [Add_on_list, setAdd_on_list] = useState([]);
	const [Add_on_list1, setAdd_on_list1] = useState([]);
	const [Selected_Add_on_list, setSelected_Add_on_list] = useState([]);
	const [All_add_on, setAll_add_on] = useState([]);
	const [addon_price, setaddon_price] = useState("");

	var page_name = "subscription-details";

	const { user, organization_id, user_role, organization_name,organization_currency, setPaymentResponseFlag } = useAuthData();
	const { theme, dropdownStyleDark } = useTheme();
	const history = useHistory()

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	async function getOrganizationAdmin() {

		var object = {};
		object.email = user.email;


		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-Organization-Admin`, { method: 'POST', body: JSON.stringify({ "email": user.email, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.operation == "success") {
			setOrganization_admin(body.data[0].user_id);
		}
	}

	async function getlivecurrency() {
		var object = {};
		object.email = user.email;

		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-live-currency`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.length > 0) {
			let arr = [];
			arr.push(body[0].data.quotes)
			setLiveCurrencyData(arr);
		}
	}

	async function getPaymentLogDetails() {
		var object = {};
		object.email = user.email;
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-payment-wallet-details`, { method: 'POST', body: JSON.stringify({ "email": user.email, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		if (body.operation == "success" && body.data.length > 0) {
			setWalletAmount(body.data[0].amount);
		}
	}

	async function getBillingAddress() {

		setApiState(true)
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/check-billing-address`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		setApiState(false)
		if (body.data == "found") {
			setbilling_address(body.value);
			if (body.value.find(option => option.default == "true") !== undefined) {
				setselected_billing_address(body.value.find(option => option.default == "true"));
			}
		}
	}

	async function getAddonFeatures() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-add-on-features`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		setAll_add_on(body.data)
	}

	async function getPurchaseList() {
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-current-active-purchase-plan`, { method: 'POST', body: JSON.stringify({ "email": user.email, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();
		setsubscription_list(body.data);
	}

	async function getsubscriptiondetails() {
		var object = {};
		object.product = props.match.params.id;
		const response = await fetch(
			`${process.env.REACT_APP_SERVER_URL}/get-subscription-details/${props.match.params.id}`, { method: 'GET', headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
		);
		const body = await response.json();

		if (body.data.length > 0) {
			body.data.map((obj, index) => {
				obj.subscription_charges = JSON.parse(obj.subscription_charges);
				obj.subscription_features = JSON.parse(obj.subscription_features);
				obj.add_on_features = (obj.add_on_features);
			});
			setsubscription_details(body.data);
		}
	}

	useEffect(() => {
		if (user !== null && user.email) {
			let p1 = getPurchaseList()
			let p2 = getBillingAddress();
			let p3 = getAddonFeatures();
			let p4 = getsubscriptiondetails();
			let p5 = getPaymentLogDetails();
			//let p6 = getlivecurrency();
			let p6 = getOrganizationAdmin();
			Promise.all([p1, p2, p3, p4, p5, p6])
				.then(() => {
					setstate(1)
					console.log("all apis done")
				})
				.catch((err) => {
					setstate(0)
					console.log(err)
				})
		}
	}, [user])

	useEffect(() => {

		if (LiveCurrencyData.length > 0  && organization_currency!==null) {
			const conversion_value = Math.round((LiveCurrencyData[0]["USD" + organization_currency.currency_code]) * 100) / 100;
			setCurrency_conversion_value(conversion_value);
		}
	}, [organization_currency, LiveCurrencyData])

	useEffect(() => {
		var obj_array = [];
		var obj2 = {};
		country_arr.country_arr.map((obj, index) => {
			obj2 = {};
			obj2.label = obj;
			if (index > 0) {
				obj2.value = obj;
			}
			else {
				obj2.value = "";
			}
			obj_array.push(obj2);
		})
		set_country_array(obj_array);

	}, [user])

	useEffect(() => {
		if (subscription_details.length > 0 && organization_currency!==null) {
			let arr = subscription_details;
			let currency1 = organization_currency.currency_code;
			arr.map((obj, index) => {
				var json = (obj.subscription_charges);
				var json2 = (obj.subscription_features);
				var json3 = (obj.add_on_features);
				obj.subscription_charges = json;
				obj.subscription_features = json2;
				json.map((obj2, index2) => {
					//console.log(obj2)
					if (currency1 == obj2.currency || (obj2.default == "Yes" && currency1 == "default")) {
						obj.currency = obj2.currency;

						if (currency1 == "default") {
							currency1 = obj2.currency
						}

						obj2.charges.map((obj3, index3) => {
							if (obj3.duration_in_month == "1") {
								obj.monthly_charge = Number(obj3.charges - obj3.discount_amount);
								obj.monthly_charge_without_discount = obj3.charges;
								obj.monthly_charge_unit = obj3.duration_in_letter;
								obj.monthly_discount = obj3.discount_amount;
								obj.price = Number(obj3.charges - obj3.discount_amount);
							}
							if (obj3.duration_in_month == "12") {
								obj.yearly_charge = Number(obj3.charges - obj3.discount_amount);
								obj.yearly_charge_without_discount = obj3.charges;
								obj.yearly_charge_unit = obj3.duration_in_letter;
								obj.yearly_discount = obj3.discount_amount;
								obj.price = Number(obj3.charges - obj3.discount_amount);
							}
							if (obj3.duration_in_month == "3") {
								obj.quarterly_charge = Number(obj3.charges - obj3.discount_amount);
								obj.quarterly_charge_without_discount = obj3.charges;
								obj.quarterly_charge_unit = obj3.duration_in_letter;
								obj.quarterly_discount = obj3.discount_amount;
								obj.price = Number(obj3.charges - obj3.discount_amount);
							}
							if (obj3.duration_in_month == "6") {
								obj.half_yearly_charge = Number(obj3.charges - obj3.discount_amount);
								obj.half_yearly_charge_without_discount = obj3.charges;
								obj.half_yearly_charge_unit = obj3.duration_in_letter;
								obj.half_yearly_discount = obj3.discount_amount;
								obj.price = Number(obj3.charges - obj3.discount_amount);
							}
						})
					}
				})
			})
			let dur = getCookie("dur");

			if (dur != undefined && dur != "") {
				setDuration(dur)
			}
			setSubscription(arr)
			if (dur != undefined && dur != "") {
				if (dur === "mon") {
					setprice(arr[0].monthly_charge);
					setExpiryDate(moment.utc().add(30, 'days').format('YYYY-MM-DD'))
				}
				else if (dur === "3 mon") {
					setprice(arr[0].quarterly_charge);
					setExpiryDate(moment.utc().add(90, 'days').format('YYYY-MM-DD'))
				}
				else if (dur === "6 mon") {
					setprice(arr[0].half_yearly_charge);
					setExpiryDate(moment.utc().add(180, 'days').format('YYYY-MM-DD'))
				}
				else {
					setprice(arr[0].yearly_charge);
					setExpiryDate(moment.utc().add(365, 'days').format('YYYY-MM-DD'))
				}

			}
			else {
				setprice(arr[0].monthly_charge);
			}
			setsubscription_pattern(arr[0].subscription_pattern);
			setstate(1);
		}

	}, [organization_currency, subscription_details])

	useEffect(() => {
		if (All_add_on.length > 0 && subscription != "") {
			subscription.map((obj, index) => {
				var json3 = JSON.parse(obj.add_on_features).length > 0 ? JSON.parse(obj.add_on_features) : [];
				let arr = [];
				json3.map((obj3, index3) => {
					arr.push({ value: obj3.feature, label: All_add_on.filter(option => option.unique_id == obj3.feature)[0].feature_name })
				})
				setAdd_on_list1(json3);
				setAdd_on_list(arr);
			})
		}

	}, [user, All_add_on, subscription])

	useEffect(() => {
		let updated_price = (price * user_count + addon_price);
		if (discount_type !== "") {
			if (discount_type == "Percentage") {
				updated_price -= (updated_price * discount_value) / 100;
			}
			else if (discount_type == "Amount") {
				updated_price -= discount_value
			}
		}
		setdiscounted_price(updated_price)

	}, [price, addon_price, discount_type, discount_value])

	const initializeRazorpay = () => {
		return new Promise((resolve) => {
			const script = document.createElement("script");
			script.src = "https://checkout.razorpay.com/v1/checkout.js";

			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};

			document.body.appendChild(script);
		});
	};

	const set_price = (dur) => {
		setSelected_Add_on_list([]);
		setAdd_on_list([]);
		setAdd_on("");
		setAdd_on1("");
		if (dur == "mon") {
			setprice(subscription[0].monthly_charge)
			setExpiryDate(moment.utc().add(30, 'days').format('YYYY-MM-DD'))
		}
		else if (dur === "3 mon") {
			setprice(subscription[0].quarterly_charge);
			setExpiryDate(moment.utc().add(90, 'days').format('YYYY-MM-DD'))
		}
		else if (dur === "6 mon") {
			setprice(subscription[0].half_yearly_charge);
			setExpiryDate(moment.utc().add(180, 'days').format('YYYY-MM-DD'))
		}
		else if (dur == "year") {
			setprice(subscription[0].yearly_charge)
			setExpiryDate(moment.utc().add(365, 'days').format('YYYY-MM-DD'))
		}
		subscription.map((obj, index) => {
			var json3 = JSON.parse(obj.add_on_features).length > 0 ? JSON.parse(obj.add_on_features) : [];
			//var json3 = obj.add_on_features.length > 0 ? JSON.parse(obj.add_on_features).filter(option => option.duration == dur)[0].features : [];
			let arr = [];
			json3.map((obj3, index3) => {
				arr.push({ value: obj3.feature, label: All_add_on.filter(option => option.unique_id == obj3.feature)[0].feature_name })
			})
			setAdd_on_list1(json3);
			setAdd_on_list(arr);
		})
	}

	function loadState(country) {
		setstate1("");
		var selectedCountryIndex = 0;
		country_array.map((obj, index) => {
			if (obj.value == country.value) {
				selectedCountryIndex = index;
			}
		})

		setcountry(country.value);

		set_state_array([]);
		setstate1("");

		var state_arr = s_a.s_a[selectedCountryIndex].split("|");

		var obj_array = [];
		var obj2 = {};

		obj_array.push({ value: "", label: "Select State" });
		for (let i = 0; i < state_arr.length; i++) {
			obj_array.push({ value: state_arr[i], label: state_arr[i] });
		}
		set_state_array(obj_array);
	}

	const wallet_modal = async () => {
		setWalletModalShow(true);
	}

	const purchase_plan_wallet = async () => {

		if (user.email != Organization_admin) {
			swal("Permission Denied!", "You don't have any permission to purchase. Please reach out to your Admin.", "warning").then((value) => {

			});
			return false;
		}
		var object = {};
		object.flag = "subscription";
		object.currency = organization_currency.currency_code;
		object.quantity = user_count;
		object.payment_mode = payment_mode;
		if (duration == "mon") {
			object.duration = "month";
		}
		else if (duration == "year") {
			object.duration = "yearly";
		}
		object.price = price;
		if (discounted_price == "") {
			object.total_price = Math.round(price * user_count * 100) / 100
		}
		else {
			object.total_price = Math.round(discounted_price * 100) / 100
		}
		object.organization_id = organization_id;
		object.purchase_flag = "Purchase";
		object.product_id = subscription[0].product_id;
		object.page_name = page_name;
		const result = subscription_list.filter(item => item.add_status == "Active" && item.product_id == subscription[0].product_id);
		var purchase_flag = 0;
		let now = new Date();
		object.upgrade = 0;
		object.upgrade = 1;
		object.discount = "";
		for (var i = 0; i < subscription_list.length; i++) {
			if (subscription_list[i].add_status == "Active" && subscription_list[i].product_id == subscription[0].product_id && subscription_list[i].subscription_plan < object.price && subscription_list[i].currency == object.currency) {
				now = moment(now);
				let end = moment(subscription_list[i].starting_date).format('YYYY-MM-DD');
				var duration_date = moment.duration(now.diff(end));

				if (duration_date.asDays() > 0) {
					var discount = subscription_list[i].subscription_plan - (Math.ceil(duration_date.asDays()) * (subscription_list[i].subscription_plan / 30));
					var percentage = discount * 100 / object.price;
					object.discount = percentage;
					object.upgrade = 1;
					purchase_flag = 1;
				}
				break;
			}
		}
		if (result.length > 0) {
			if (purchase_flag == 0) {
				swal("Warning!", "Similar or higher plan is already active. If you still want to continue then you need to cancel your existing subscription.", "warning").then((res) => {
				});
				return false;
			}
		}

		object.email = user.email;
		if (object.discount != "") {
			object.discount_type = "Percentage";
		}
		else {
			object.discount_type = discount_type;
		}
		if (object.discount != "") {
			object.discount_value = object.discount + discount_value;
			object.discount_value = parseFloat(object.discount_value).toFixed(2);
		}
		else {
			object.discount_value = discount_value;
		}
		object.subscription_id = props.match.params.id;
		object.starting_date = moment.utc().format('YYYY-MM-DD');
		object.ending_date = expiry_date;
		object.billing_address = selected_billing_address;
		if (selected_billing_address === null) {
			swal("Warning!", "Need to select one address for billing.", "warning");
			return false;
		}
		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		object.response = "";
		object.organization_id = organization_id;
		object.Selected_Add_on_list = Selected_Add_on_list;
		object.addon_price = addon_price;
		object.amount = discounted_price;
		object.currency = organization_currency.currency_code;
		object.referal_code = referal_code;
		object.currency_conversion_value = Currency_conversion_value;
		setMainSubmitButtonState(true);
		if (Number(discounted_price) - Number(WalletAmount) <= 0) {
			object.payment_gateway = "E-Wallet";
			axios.post(`${process.env.REACT_APP_SERVER_URL}/purchase-plan-wallet`, object, headers).then(async (res) => {
				if (res.data && res.data.operation == "success") {
					swal("Great!", "Plan Activate successfully!", "success").then((value) => {
						setPaymentResponseFlag("success");
						history.push("/subscription-history");
					});
				}
			});
		}
		else {
			const res = await initializeRazorpay();
			if (!res) {
				alert("Razorpay SDK Failed to load");
				return;
			}
			object.payment_gateway = "E-Wallet";
			axios.post(`${process.env.REACT_APP_SERVER_URL}/purchase-plan`, object, headers).then(async (res) => {
				if (res.data && res.data.operation == "success") {
					object.amount = Number(discounted_price) - Number(WalletAmount);
					object.payment_flag = "instant";
					object.ref_id = res.data.id;
					axios.post(`${process.env.REACT_APP_SERVER_URL}/add-payment-wallet-log`, object, headers).then(async (res1) => {
						if (res.data && res.data.operation == "success") {
							const orderUrl = `${process.env.REACT_APP_SERVER_URL}/create-session-wallet-recharge`;
							object.id = res1.data.id;
							object.type = "Instant_Wallet_Recharge";
							const response = await axios.post(orderUrl, object, headers);
							const { data } = response;
							var options = {
								key: process.env.REACT_APP_RAZOR_PAY_KEY_ID, // Enter the Key ID generated from the Dashboard
								name: "SpotERP",
								currency: data.currency,
								order_id: data.id,
								amount: object.amount,
								image: `${process.env.REACT_APP_LOGO}`,
								handler: async (response) => {

									// Validate payment at server - using webhooks is a better idea.
									try {
										const payment_object = {};
										payment_object.amount = object.amount;
										payment_object.razorpay_payment_id = response.razorpay_payment_id;
										payment_object.razorpay_signature = response.razorpay_signature;
										payment_object.razorpay_order_id = response.razorpay_order_id;
										const captureUrl = `${process.env.REACT_APP_SERVER_URL}/capture-razorpay-payment`;
										const captureResponse = await axios.post(captureUrl, payment_object, headers)
										if (captureResponse.data) {
											setPaymentResponseFlag("success");
											history.push("/subscription-history");
										}
									}
									catch (err) {
										console.log(err);
									}
								},
								prefill: {
									name: selected_billing_address?.full_name,
									email: selected_billing_address?.email,
									contact: selected_billing_address?.phone,
								}
							}
							const paymentObject = new (window).Razorpay(options);
							paymentObject.open();
						}
					})
				}
				else {
					swal("Oops!", "Something went wrong!", "error");
				}
			})
		}
	}

	const purchase_plan = async () => {

		if (user.email != Organization_admin) {
			swal("Permission Denied!", "You don't have any permission to purchase. Please reach out to your Admin.", "warning").then((value) => {

			});
			return false;
		}

		var object = {};
		object.flag = "subscription";
		object.currency = organization_currency.currency_code;
		object.quantity = user_count;
		object.payment_mode = payment_mode;
		object.referal_code = referal_code;
		if (duration == "mon") {
			object.duration = "month";
		}
		else if (duration == "3 mon") {
			object.duration = "quarterly";
		}
		else if (duration == "6 mon") {
			object.duration = "half_yearly";
		}
		else if (duration == "year") {
			object.duration = "yearly";
		}
		object.price = price;
		if (discounted_price == "") {
			object.total_price = Math.round(price * user_count * 100) / 100
		}
		else {
			object.total_price = Math.round(discounted_price * 100) / 100
		}
		object.organization_id = organization_id;
		object.purchase_flag = "Purchase";
		object.product_id = subscription[0].product_id;
		object.page_name = page_name;
		const result = subscription_list.filter(item => item.add_status == "Active" && item.product_id == subscription[0].product_id);
		var purchase_flag = 0;
		let now = new Date();
		object.upgrade = 0;
		object.upgrade = 1;
		object.discount = "";
		for (var i = 0; i < subscription_list.length; i++) {
			if (subscription_list[i].add_status == "Active" && subscription_list[i].product_id == subscription[0].product_id && subscription_list[i].subscription_plan < object.price && subscription_list[i].currency == object.currency) {
				now = moment(now);
				let end = moment(subscription_list[i].starting_date).format('YYYY-MM-DD');
				var duration_date = moment.duration(now.diff(end));

				if (duration_date.asDays() > 0) {
					var discount = subscription_list[i].subscription_plan - (Math.ceil(duration_date.asDays()) * (subscription_list[i].subscription_plan / 30));
					var percentage = discount * 100 / object.price;
					object.discount = percentage;
					object.upgrade = 1;
					purchase_flag = 1;
				}
				break;
			}
		}
		if (result.length > 0) {
			if (purchase_flag == 0) {
				swal("Warning!", "Similar or higher plan is already active. If you still want to continue then you need to cancel your existing subscription.", "warning").then((res) => {
				});
				return false;
			}
		}

		object.email = user.email;
		// if (object.discount != "") {
		// 	object.discount_type = "Percentage";
		// }
		// else {
		// 	object.discount_type = discount_type;
		// }
		// if (object.discount != "") {
		// 	object.discount_value = object.discount + discount_value;
		// 	object.discount_value = parseFloat(object.discount_value).toFixed(2);
		// }
		// else {
		// 	object.discount_value = discount_value;
		// }
		object.subscription_id = props.match.params.id;
		object.starting_date = moment.utc().format('YYYY-MM-DD');
		object.ending_date = expiry_date;
		object.billing_address = selected_billing_address;
		//console.log(selected_billing_address);
		if (selected_billing_address === null) {
			swal("Warning!", "Need to select one address for billing.", "warning");
			return false;
		}

		paymentHandlerRazorpay(object);
	}

	const paymentHandlerRazorpay = async (object) => {
		const res = await initializeRazorpay();
		if (!res) {
			alert("Razorpay SDK Failed to load");
			return;
		}
		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		object.response = "";
		object.payment_gateway = "Razorpay";
		object.organization_id = organization_id;
		object.Selected_Add_on_list = Selected_Add_on_list;
		object.addon_price = addon_price;
		object.amount = discounted_price;
		object.referal_code = referal_code;
		setMainSubmitButtonState(true);

		axios.post(`${process.env.REACT_APP_SERVER_URL}/purchase-plan`, object, headers).then(async (res) => {
			if (res.data && res.data.operation == "success") {
				const sessionUrl = payment_mode == "Recurring" ? `create-session-subscription` : `create-session-order`;
				const orderUrl = `${process.env.REACT_APP_SERVER_URL}/${sessionUrl}`;
				var payment_object = {};
				payment_object.id = res.data.id;
				payment_object.email = user.email;

				object.id = res.data.id;
				object.type = "Plan_purchase";
				object.offer_id = offerId;
				object.coupon_code = coupon_code;
				object.address = selected_billing_address;
				const response = await axios.post(orderUrl, object, headers);
				const { data } = response;
				var options = {
					key: process.env.REACT_APP_RAZOR_PAY_KEY_ID, // Enter the Key ID generated from the Dashboard
					name: "SpotERP",
					currency: data.currency,
					order_id: data.id,
					//subscription_id: data.id,
					amount: discounted_price,
					image: `${process.env.REACT_APP_LOGO}`,
					handler: async (response) => {

						// Validate payment at server - using webhooks is a better idea.
						try {
							payment_object.amount = Number(price);
							payment_object.razorpay_payment_id = response.razorpay_payment_id;
							payment_object.razorpay_signature = response.razorpay_signature;
							payment_object.razorpay_order_id = response.razorpay_order_id;
							const captureUrl = `${process.env.REACT_APP_SERVER_URL}/capture-razorpay-payment`;
							const captureResponse = await axios.post(captureUrl, payment_object, headers)
							if (captureResponse.data) {
								setPaymentResponseFlag("success");
								history.push("/subscription-history");
							}
						}
						catch (err) {
							console.log(err);
						}
					},
					prefill: {
						name: selected_billing_address?.full_name,
						email: selected_billing_address?.email,
						contact: selected_billing_address?.phone,
					}
				}
				const paymentObject = new (window).Razorpay(options);
				paymentObject.open();
			}
		})
	};

	const new_address = () => {
		setaddress_id("")
		setcountry("")
		setname("");
		setphone("")
		setstate1("")
		setpincode("")
		setcity("")
		setaddress_line1("")
		setaddress_line2("");
		set_state_array([]);
		setAddressModalShow(true);
	}
	const update_address = (i) => {
		setcountry(billing_address[i].country)
		var selectedCountryIndex = 0;
		country_array.map((obj, index) => {
			if (obj.value == billing_address[i].country) {
				selectedCountryIndex = index;
			}
		})

		var state_arr = s_a.s_a[selectedCountryIndex].split("|");

		var obj_array = [];
		var obj2 = {};
		state_arr.map((obj, index) => {
			obj2 = {};
			obj2.label = obj;
			if (index > 0) {
				obj2.value = obj;
			}
			else {
				obj2.value = "";
			}
			obj_array.push(obj2);
		})
		set_state_array(obj_array);
		setaddress_id(billing_address[i].unique_id)
		setname(billing_address[i].full_name);
		setphone(billing_address[i].phone)
		setstate1(billing_address[i].state)
		setpincode(billing_address[i].pincode)
		setcity(billing_address[i].city)
		setaddress_line1(billing_address[i].address_line1)
		setaddress_line2(billing_address[i].address_line2);
		setAddressModalShow(true);
	}

	const update_billing_address = () => {
		let object = {}
		object.address_details = {};
		object.address_details.address_id = address_id;
		object.address_details.full_name = name;
		object.address_details.country = country;
		object.address_details.state = state1;
		object.address_details.billing_email = user.email;
		object.address_details.phone = phone;
		object.address_details.pincode = pincode;
		object.address_details.city = city;
		object.address_details.address_line1 = address_line1;
		object.address_details.address_line2 = address_line2;
		object.address_details.email = user.email;
		object.address_details.organization_id = organization_id;
		if (object.address_details.full_name == "") {
			swal("Warning!", "Provide a name", "warning");
			return false;
		}
		else if (!isNaN(object.address_details.full_name)) {
			swal("Warning!", "Provide a name", "warning");
			return false;
		}

		if (object.address_details.country == "") {
			swal("Warning!", "Provide a country", "warning");
			return false;
		}
		else if (!isNaN(object.address_details.country)) {
			swal("Warning!", "Provide a country", "warning");
			return false;
		}

		if (object.address_details.state == "") {
			swal("Warning!", "Provide a state", "warning");
			return false;
		}
		else if (!isNaN(object.address_details.state)) {
			swal("Warning!", "Provide a state", "warning");
			return false;
		}

		if (object.address_details.billing_email == "") {
			swal("Warning!", "Provide a email", "warning");
			return false;
		}
		else if (!isNaN(object.address_details.billing_email)) {
			swal("Warning!", "Provide a email", "warning");
			return false;
		}

		if (object.address_details.phone == "") {
			swal("Warning!", "Provide a phone", "warning");
			return false;
		}

		if (object.address_details.pincode == "") {
			swal("Warning!", "Provide a Zip Code", "warning");
			return false;
		}
		if (object.address_details.address_line1 == "") {
			swal("Warning!", "Please fill the Address Line1", "warning");
			return false;
		}
		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		setMainSubmitButtonState(true);
		if (address_id != "") {
			axios.post(`${process.env.REACT_APP_SERVER_URL}/update-address`, object, headers).then((res) => {
				if (res.data && res.data.operation == "success") {
					swal("Great!", "Address updated successfully!", "success").then((value) => {
						window.location.reload();
						setMainSubmitButtonState(false);
					});
				}
				else {
					swal("Oops!", "Something went wrong!", "error");
				}
			});
		}
		else {
			axios.post(`${process.env.REACT_APP_SERVER_URL}/add-address`, object, headers).then((res) => {
				if (res.data && res.data.operation == "success") {
					swal("Great!", "Address saved successfully!", "success").then((value) => {
						setAddressModalShow(false);
						setMainSubmitButtonState(false);
						getBillingAddress();
					});
				}
				else {
					swal("Oops!", "Something went wrong!", "error");
				}
			});
		}
	}

	const checkCouponAvailability = (e) => {
		e.preventDefault();
		var object = {};
		let dur = "";
		if (duration == "mon") {
			dur = "month";
		}
		else {
			dur = "year";
		}
		object.id = subscription[0].product_id + "(" + dur + ")";
		object.subscription_type = "Paid"
		object.coupon_code = coupon_code;
		object.page_name = page_name;

		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		setMainSubmitButtonState(true)
		axios.post(`${process.env.REACT_APP_SERVER_URL}/check-coupon-availabilty`, object, headers).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data.operation == "success") {
				if (res.data.data == "found") {
					swal("Great!", "Coupon applied successfully!", "success").then((value) => {
						setOfferId(res.data.value.offer_id);
						setdiscount_type(res.data.value.coupon_type)
						setdiscount_value(res.data.value.coupon_value)
					});
				}
				else if (res.data.data == "not found") {
					swal("Oops!", "Invalid coupon", "error").then((res) => {
						setOfferId("");
						setdiscount_type("");
						setdiscount_value("");
					});
				}
				else if (res.data.data == "not available for this product") {
					swal("Oops!", "This coupon is not available for this product", "error").then((res) => {
						setdiscount_type("");
						setdiscount_value("");
					});
				}
				else if (res.data.data == "not available for this user") {
					swal("Oops!", "This coupon is only available for selected users", "error").then((res) => {
						setdiscount_type("");
						setdiscount_value("");
					});
				}
				else if (res.data.data == "not available" && res.data.subscription_type == "Paid") {
					swal("Oops!", "This coupon is not available for paid subscription", "error").then((res) => {
						setdiscount_type("");
						setdiscount_value("");
					});
				}
				else if (res.data.data == "not available" && res.data.subscription_type == "Trial") {
					swal("Oops!", "This coupon is not available for trial subscription", "error").then((res) => {
						setdiscount_type("");
						setdiscount_value("");
					});
				}

			}
			else {
				if (res.data.message != "danger") {
					swal("Oops!", res.data.message, "error").then((res) => {
						setdiscount_type("");
						setdiscount_value("");
					});
				}
				else {
					swal("Oops!", "Invalid coupon", "error").then((res) => {
						setdiscount_type("");
						setdiscount_value("");
					});
				}
			}
		})
			.catch(function (error) {
				swal("Oops!", "something went wrong", "error").then((res) => {
					setdiscount_type("");
					setdiscount_value("");
				});
			});
	}

	const handleInputChange = (data) => {
		let values1 = [...Selected_Add_on_list];
		let index = "";
		let temp = -1;
		if (data.filter(x => Add_on1.indexOf(x) === -1).length > 0) {
			index = data.filter(x => Add_on1.indexOf(x) === -1)[0];
			temp = 0;
		}
		else {
			index = Add_on1.filter(x => data.indexOf(x) === -1)[0];
			temp = 1;
		}
		if (temp == 0) {
			let Addon = All_add_on.filter(option => option.unique_id == index)[0];
			let update_Addon = Add_on_list1.filter(option => option.feature == index)[0];
			//console.log("update_Addon", update_Addon);
			values1.push({ Add_on_id: index, Add_on_feature: Addon.feature_name, value: update_Addon.value, price: update_Addon.price, unit: update_Addon.unit, quantity: "1", min_count: update_Addon.min_count })
		}
		else {
			values1 = values1.filter(function (obj) {
				return obj.Add_on_id !== index;
			});
		}
		let subtotal = 0;
		for (let i = 0; i < values1.length; i++) {
			subtotal = subtotal + parseInt(values1[i].price) * parseInt(values1[i].quantity);
		}
		setaddon_price(subtotal);
		setSelected_Add_on_list(values1)
	}

	const Count_input_change = (data, min_count) => {
		//console.log(min_count);
		const values1 = [...Selected_Add_on_list];
		let subtotal = 0;
		for (let i = 0; i < values1.length; i++) {
			subtotal = subtotal + parseInt(values1[i].price) * parseInt(values1[i].quantity);
		}
		setaddon_price(subtotal);
	}

	return (
		<>
			<div className="d-flex flex-column flex-column-fluid">
				<div className="app-toolbar py-3 py-lg-6" id="kt_app_toolbar">
					<div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
						<h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Subscricption Details
							<small className="text-muted fs-7 fw-bold my-1 ms-1"></small>
						</h1>
						<span className="badge badge-success fs-5">{organization_name}</span>
					</div>
				</div>
				<div id="kt_app_content" className="app-content flex-column-fluid">
					<div id="kt_app_content_container" className="app-container container-xxl">
						{state == 1 ?
							<>
								<div className="row">
									<div className="col-md-8 card card-flush px-0 mb-3">
										<div className="card-body p-3">
											<Tabs activeKey={navtype} onSelect={(key) => { setnavtype(key) }} className="mb-3">
												<Tab eventKey="Billing_Address" title="Billing Address">
													<>
														<div className="d-flex align-items-center justify-content-end gap-2 gap-lg-3">
															{billing_address.length <= 3 &&
																<a onClick={new_address} className="btn btn-sm btn-primary rounded btn-hover-scale">
																	<span className="d-md-none">
																		<svg width="15" height="15" viewBox="0 0 11 11" fill="none">
																			<path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff">
																			</path>
																		</svg>
																	</span>
																	<span className="d-none d-md-inline">Add Address</span>
																</a>
															}
															<a onClick={getBillingAddress} className="btn btn-sm btn-light btn-primary rounded">
																<span className="d-md-none">
																	<i className="las la-sync px-0" style={{ "font-size": "20px" }}></i>
																</span>
																<span className="d-none d-md-inline">
																	Sync
																</span>
															</a>
														</div>
														<div className="row gx-0 my-2" style={{ transition: "all 1s ease-in-out", opacity: !apiState ? "1" : "0", visibility: !apiState ? "visible" : "hidden", height: !apiState ? "auto" : "0", marginBottom: !apiState ? "1rem" : "0" }}>
															{billing_address.map((address, index) => {
																return (
																	<>
																		<div className="col-md-6 p-1" onClick={(e) => { setselected_billing_address(address); }}>
																			<div className={`card p-4 shadow-sm rounded cursor-pointer ${(address.unique_id == selected_billing_address.unique_id)?"border border-3 border-primary":""}`}>
																				<div className="card-header min-h-25px d-flex align-items-center fs-5 fw-bold text-primary">
																					<div className='card-title'>Address {index + 1}</div>
																					<div className='card-toolbar'>
																						<button onClick={(e) => { update_address(index); }} className="btn btn-sm btn-outline-primary ms-3">
																							<i className="fa-solid fa-pencil fs-5"></i>
																						</button>
																					</div>
																					{/* {(address.unique_id == selected_billing_address.unique_id) && <span className="badge badge-success">Selected</span>} */}
																				</div>
																				<div className=" card-body">
																					<div className="mb-2">
																						<span className="fw-semibold text-muted">Address 1: </span>
																						<span className="fs-6 text-dark fw-bold">{address.address_line1 || "NA"}</span>
																					</div>
																					{address.address_line2 && (
																						<div className="mb-2">
																							<span className="fw-semibold text-muted">Address 2: </span>
																							<span className="fs-6 text-dark fw-bold">{address.address_line2}</span>
																						</div>
																					)}
																					<div className="row mb-2">
																						<div className="col-md-6">
																							<span className="fw-semibold text-muted">City: </span>
																							<span className="fs-6 text-dark fw-bold">{address.city}</span>
																						</div>
																						<div className="col-md-6">
																							<span className="fw-semibold text-muted">Pincode: </span>
																							<span className="fs-6 text-dark fw-bold">{address.pincode}</span>
																						</div>
																					</div>
																					<div className="row">
																						<div className="col-md-6">
																							<span className="fw-semibold text-muted">State: </span>
																							<span className="fs-6 text-dark fw-bold">{address.state}</span>
																						</div>
																						<div className="col-md-6">
																							<span className="fw-semibold text-muted">Country: </span>
																							<span className="fs-6 text-dark fw-bold">{address.country}</span>
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																	</>
																);
															}
															)}
														</div>
													</>
												</Tab>
												<Tab eventKey="Plan_Details" title="Plan Details">
													<>
														<div className="mb-10 fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-valid">
															<label className="fs-5 fw-bold mb-2">Payment Frequency
																<i className="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="" data-bs-original-title="Provide your team size to help us setup your billing" aria-label="Provide your team size to help us setup your billing"></i></label>
															<div className="row mb-2" data-kt-buttons="true">
																{subscription[0].subscription_charges[0].charges.filter(item => item.duration_in_letter == "month").length > 0 &&
																	<div className="col">
																		<label className={`btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 ${duration == "mon" && "active"}`}>
																			<input onClick={(e) => { setDuration("mon"); set_price("mon"); }} type="radio" className="btn-check" name="account_team_size" value="1-1" />
																			<span className="fw-bolder fs-3">Monthly</span>
																		</label>
																	</div>
																}
																{subscription[0].subscription_charges[0].charges.filter(item => (item.duration_in_letter == "month" && item.duration_in_month == "3")).length > 0 &&
																	<div className="col">
																		<label className={`btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 ${duration == "3 mon" && "active"}`}>
																			<input onClick={(e) => { setDuration("3 mon"); set_price("3 mon"); }} type="radio" className="btn-check" name="account_team_size" value="1-1" />
																			<span className="fw-bolder fs-3">Quarterly</span>
																		</label>
																	</div>
																}
																{subscription[0].subscription_charges[0].charges.filter(item => (item.duration_in_letter == "month" && item.duration_in_month == "6")).length > 0 &&
																	<div className="col">
																		<label className={`btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 ${duration == "6 mon" && "active"}`}>
																			<input onClick={(e) => { setDuration("6 mon"); set_price("6 mon"); }} type="radio" className="btn-check" name="account_team_size" value="1-1" />
																			<span className="fw-bolder fs-3">Half yearly</span>
																		</label>
																	</div>
																}
																{subscription[0].subscription_charges[0].charges.filter(item => item.duration_in_letter == "yearly").length > 0 &&
																	<div className="col">
																		<label className={`btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4 ${duration == "year" && "active"}`}>
																			<input onClick={(e) => { setDuration("year"); set_price("year"); }} type="radio" className="btn-check" name="account_team_size" value="1-1" />
																			<span className="fw-bolder fs-3">Yearly</span>
																		</label>
																	</div>
																}
															</div>

														</div>
														<div className="col-md-12 fv-row">
															<label className="fs-5 fw-bold mb-2">Payment Mode:
																<i className="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title="" data-bs-original-title="Show your ads to either men or women, or select 'All' for both" aria-label="Show your ads to either men or women, or select 'All' for both"></i></label>
															<div className="row g-9">
																<div className="col">
																	<label className={`btn btn-outline btn-outline-dashed btn-outline-default d-flex text-start p-6 ${payment_mode == "Non Recurring" && "active"}`} >
																		<span className="form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1">
																			<input className="form-check-input" type="radio" name="campaign_gender" onClick={(e) => { setpayment_mode("Non Recurring"); }} value="2" checked={`${payment_mode == "Non Recurring" ? "checked" : ""}`} />
																		</span>
																		<span className="ms-5">
																			<span className="fs-4 fw-bolder text-gray-800 d-block">Non Recurring Payment</span>
																		</span>
																	</label>
																</div>
															</div>
														</div>
													</>
												</Tab>
												<Tab eventKey="Add_On" title="Add On">
													<>
														<div className="row mb-5">
															<div className="col-md-12 fv-row">
																<label className=" fs-5 fw-bold mb-2">Select Add On</label>
																<Select
																	isMulti
																	className="form-control form-control-solid"
																	options={Add_on_list}
																	onChange={(e) => { handleInputChange(Array.isArray(e) ? e.map(x => x.value) : []); setAdd_on(Array.isArray(e) ? e.map(x => x.label) : []); setAdd_on1(Array.isArray(e) ? e.map(x => x.value) : []); }}
																	placeholder="--Select--"
																/>
															</div>
															{Selected_Add_on_list.length > 0 &&
																<div className="table-responsive">
																	<table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
																		<thead>
																			<tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
																				<th className="min-w-150px">Add On</th>
																				<th className="min-w-50px w-150px">Quantity</th>
																				<th className="min-w-50px w-150px">SMS Count</th>
																				<th className="min-w-50px w-150px">Total Price</th>

																			</tr>
																		</thead>
																		<tbody className="fw-bold text-gray-600">
																			{Selected_Add_on_list.map((obj, index) => {
																				return (
																					<>
																						<tr>
																							<td >

																								<div className="d-flex justify-content-start flex-column">
																									<span className="text-dark fw-bolder text-hover-primary fs-6">{obj.Add_on_feature}</span>
																									<span className="text-muted fw-bold text-muted d-block fs-7">{subscription[0].currency == "USD" ? <>$</> : <>Rs.</>}{obj.price}/Credit ({obj.value}{obj.unit})</span>
																								</div>
																							</td>
																							<td>
																								<input className="form-control" type="number" min="1" name="quantity"
																									onChange={(event) => {
																										const values1 = [...Selected_Add_on_list];
																										values1[index].quantity = event.target.value;
																										setSelected_Add_on_list(values1);
																										Count_input_change(event.target.value, obj);
																									}}
																									value={obj.quantity}
																								/>
																							</td>
																							<td >

																								<div className="d-flex justify-content-start flex-column">
																									<span className="text-dark fw-bolder text-hover-primary fs-6">{parseInt(obj.quantity) * parseInt(obj.value)} {obj.unit}</span>
																								</div>
																							</td>
																							<td className="text-dark fw-bolder text-hover-primary fs-6">{subscription[0].currency == "USD" ? <>$</> : <>Rs.</>}{parseInt(obj.quantity) * parseInt(obj.price)}</td>
																						</tr>
																					</>
																				);

																			}
																			)}
																			<tr>
																				<td colspan="3" className="fs-3 text-dark text-end">Total</td>
																				<td className="text-dark fs-3 fw-boldest">{subscription[0].currency == "USD" ? <>$</> : <>Rs.</>}{Math.round(addon_price * 100) / 100}</td>
																			</tr>
																		</tbody>
																	</table>
																</div>
															}
														</div>
													</>
												</Tab>
												<Tab eventKey="Review_Order" title="Review Order">
													<>
														<div className="row gx-0 mb-3">
															<div className="col-xl-6">
																<label className=" fs-5 fw-bold mb-2">Referral Key</label>
																<div className="d-flex">
																	<input type="text" className="form-control me-3 flex-grow-1" value={referal_code} onChange={(e) => {
																		setreferal_code(e.target.value);
																	}} />
																</div>
															</div>
															{PaymentMethod === "Card" &&
																<div className="col-xl-6">
																	<label className=" fs-5 fw-bold mb-2">Coupon Code</label>
																	<div className="d-flex">
																		<input type="text" className="form-control" value={coupon_code} onChange={(e) => {
																			setcoupon_code(e.target.value);
																		}}
																			placeholder="Enter coupon" name="coupon_code" id="coupon_code" />
																		<button type="submit" className="btn btn-primary btn-sm rounded" onClick={(e) => { checkCouponAvailability(e) }} id="kt_careers_submit_button"
																			data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
																			disabled={mainSubmitButtonState}
																		>APPLY</button>
																	</div>
																</div>}
														</div>
														<div className="col-md-12 fv-row">
															<label className=" fs-5 fw-bold mb-2">Payment Method</label>
															<div className="d-flex flex-equal gap-5 gap-xxl-9 px-0 mb-12" data-kt-buttons="true" data-kt-buttons-target="[data-kt-button]" data-kt-initialized="1">

																<label className={`btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 border-active-primary btn-active-light-primary w-100 px-4 ${PaymentMethod == "Card" && "active"}`} >
																	<input className="btn-check" type="radio" name="method" value="Card" onClick={(event) => { setPaymentMethod("Card") }} />
																	<i className="fonticon-card fs-2hx mb-2 pe-0"></i>
																	<span className="fs-7 fw-bold d-block">Card</span>
																</label>

																{payment_mode != "Recurring" &&
																	<label className={`btn bg-light btn-color-gray-600 btn-active-text-gray-800 border border-3 border-gray-100 border-active-primary btn-active-light-primary w-100 px-4 ${PaymentMethod == "E-Wallet" && "active"}`} >
																		<input className="btn-check" type="radio" name="method" value="E-Wallet" onClick={(event) => { setPaymentMethod("E-Wallet") }} />
																		<i className="fonticon-mobile-payment fs-2hx mb-2 pe-0"></i>
																		<span className="fs-7 fw-bold d-block">E-Wallet</span>
																	</label>}
															</div>
														</div>
													</>
												</Tab>
											</Tabs>
										</div>
										<div className='card-footer'>
											<div className="d-flex flex-stack pt-7">
												{navtype !== "Billing_Address" &&
													<div className="mr-2">
														<button type="button" className="btn btn-lg btn-primary me-3 rounded"
															onClick={() => { setnavtype((navtype == "Review_Order" && Add_on_list.length > 0) ? "Add_On" : navtype == "Plan_Details" ? "Billing_Address" : (navtype == "Add_On" || (navtype == "Review_Order" && Add_on_list.length == 0)) ? "Plan_Details" : "Review_Order") }}
														>
															<span className="svg-icon svg-icon-4 me-1">
																<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
																	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																		<polygon points="0 0 24 0 24 24 0 24" />
																		<rect fill="#000000" opacity="0.3" transform="translate(15.000000, 12.000000) scale(-1, 1) rotate(-90.000000) translate(-15.000000, -12.000000)" x="14" y="7" width="2" height="10" rx="1" />
																		<path d="M3.7071045,15.7071045 C3.3165802,16.0976288 2.68341522,16.0976288 2.29289093,15.7071045 C1.90236664,15.3165802 1.90236664,14.6834152 2.29289093,14.2928909 L8.29289093,8.29289093 C8.67146987,7.914312 9.28105631,7.90106637 9.67572234,8.26284357 L15.6757223,13.7628436 C16.0828413,14.136036 16.1103443,14.7686034 15.7371519,15.1757223 C15.3639594,15.5828413 14.7313921,15.6103443 14.3242731,15.2371519 L9.03007346,10.3841355 L3.7071045,15.7071045 Z" fill="#000000" fill-rule="nonzero" transform="translate(9.000001, 11.999997) scale(-1, -1) rotate(90.000000) translate(-9.000001, -11.999997)" />
																	</g>
																</svg>
															</span>
															Back
														</button>
													</div>
												}
												{navtype == "Review_Order" &&
													<div className="d-flex justify-content-end">
														<button type="button" className="btn btn-lg btn-success me-3 rounded" onClick={(event) => { PaymentMethod == "Card" ? purchase_plan() : wallet_modal() }} data-kt-stepper-action="submit" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}>
															<span className="indicator-label">Proceed to Pay
																<span className="svg-icon svg-icon-3 ms-2 me-0">
																	<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
																		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																			<polygon points="0 0 24 0 24 24 0 24" />
																			<rect fill="#000000" opacity="0.5" transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000)" x="7.5" y="7.5" width="2" height="9" rx="1" />
																			<path d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z" fill="#000000" fill-rule="nonzero" transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)" />
																		</g>
																	</svg>
																</span>
															</span>
															<span className="indicator-progress">Please wait...
																<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
														</button>
													</div>
												}
												{navtype !== "Review_Order" &&
													<div className="d-flex justify-content-end">
														<button type="button" className="btn btn-lg btn-primary rounded d-flex justify-content-end"
															onClick={() => { setnavtype(navtype == "Billing_Address" ? "Plan_Details" : (navtype == "Plan_Details" && Add_on_list.length > 0) ? "Add_On" : (navtype == "Add_On" || (navtype == "Plan_Details" && Add_on_list.length == 0)) ? "Review_Order" : "Billing_Address") }}
														>Continue
															<span className="svg-icon svg-icon-4 ms-1 me-0">
																<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
																	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																		<polygon points="0 0 24 0 24 24 0 24" />
																		<rect fill="#000000" opacity="0.5" transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000)" x="7.5" y="7.5" width="2" height="9" rx="1" />
																		<path d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z" fill="#000000" fill-rule="nonzero" transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997)" />
																	</g>
																</svg>
															</span>
														</button>
													</div>
												}
											</div>
										</div>
									</div>
									<div className="col-md-4 flex-column flex-lg-row-auto mb-3">
										<div className="card card-flush mb-0">
											<div className="card-header">
												<div className="card-title">
													<h2>Summary</h2>
												</div>
											</div>
											<div className="card-body p-4 fs-6">
												<div className="mb-4">

													<div className="d-flex align-items-center fs-5 fw-bold mb-3 text-primary">

														Customer details<button onClick={() => { setnavtype("Billing_Address") }} className="btn btn-sm px-3">
															<svg width="20" height="20" viewBox="0 0 1024 1024">
																<g>
																	<path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" mi-fill="rgb(115, 208, 244)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" fill="rgb(115, 208, 244)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																	</path><path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																	</path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																	</path>
																</g>
																<g ng-show="pref.showGrid" className="edit-grid ng-hide">
																	<g className="hLines"></g>
																	<g className="vLines"></g>
																</g>
															</svg>
														</button>
													</div>
													<div className="d-flex align-items-center mb-1">
														<span className="fw-bold text-gray-800 text-hover-primary me-2">{selected_billing_address?.full_name}</span>
														<span className="badge badge-light-success">Active</span>
													</div>
													<span className="fw-semibold text-gray-600 text-hover-primary">{selected_billing_address?.email},<br />{selected_billing_address?.phone}</span>
												</div>
												<div className="separator separator-dashed mb-4"></div>
												<div className="mb-4">
													<div className="d-flex align-items-center fs-5 fw-bold mb-3 text-primary">
														Subscription details <span className="badge badge-light-primary">{subscription[0].currency == "USD" ? <>$ </> : <>Rs. </>}{price} /{duration}</span><button onClick={() => { }} className="btn btn-sm px-3">
															<svg width="20" height="20" viewBox="0 0 1024 1024">
																<g>
																	<path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" mi-fill="rgb(115, 208, 244)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" fill="rgb(115, 208, 244)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																	</path><path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																	</path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																	</path>
																</g>
																<g ng-show="pref.showGrid" className="edit-grid ng-hide">
																	<g className="hLines"></g>
																	<g className="vLines"></g>
																</g>
															</svg>
														</button>
													</div>
													<table className="table fs-6 fw-semibold gs-0 gy-2 gx-2">
														<tbody><tr className="">
															<td className="text-gray-500">Subscription ID:</td>
															<td className="text-gray-800">{subscription[0].subscription_name}</td>
														</tr>
															<tr className="">
																<td className="text-gray-500">Duration:</td>
																<td className="text-gray-800">{moment.duration(moment(new Date()).diff(expiry_date)).asDays}</td>
															</tr>
															<tr className="">
																<td className="text-gray-500">End Date:</td>
																<td className="text-gray-800">{moment(expiry_date).format('ll')}</td>
															</tr>
														</tbody></table>
												</div>
												{Selected_Add_on_list.length > 0 &&
													<>
														<div className="separator separator-dashed mb-4"></div>
														<div className="mb-4">
															<div className="d-flex align-items-center fs-5 fw-bold mb-3 text-primary">
																Add On details <span className="badge badge-light-primary">{subscription[0].currency == "USD" ? <>$</> : <>Rs.</>}{Math.round(addon_price * 100) / 100}</span><button onClick={() => { setnavtype("Add_On") }} className="btn btn-sm px-3">
																	<svg width="20" height="20" viewBox="0 0 1024 1024">
																		<g>
																			<path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" mi-fill="rgb(115, 208, 244)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M261.057 569.88l187.155 187.155 436.658-436.663-187.158-187.158-436.656 436.666zM748.456 269.631c11.336 11.336 11.336 29.718 0 41.054l-306.693 306.691c-5.671 5.666-13.098 8.501-20.529 8.501-7.427 0-14.856-2.833-20.525-8.501-11.336-11.339-11.336-29.72 0-41.056l306.691-306.689c11.336-11.336 29.72-11.336 41.056 0z" fill="rgb(115, 208, 244)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																			</path><path className="cursor-pointer  transparent-most" ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M400.709 617.376c5.671 5.668 13.098 8.501 20.525 8.501 7.432 0 14.859-2.835 20.529-8.501l306.693-306.691c11.336-11.339 11.336-29.72 0-41.054-11.334-11.336-29.72-11.336-41.056 0l-306.691 306.689c-11.336 11.339-11.336 29.718 0 41.056z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																			</path><path className="cursor-pointer " ng-repeat="path in icon.paths track by tempIds[$index]" mi-d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" mi-fill="rgb(61, 104, 137)" mi-stroke="inherit" mi-stroke-width="inherit" mi-stroke-linejoin="inherit" mi-stroke-linecap="inherit" mi-stroke-miterlimit="inherit" mi-opacity="1" ng-click="selectPath($index)" mi-absorb-clicks="" d="M1010.864 185.012c-11.213-33.559-36.041-70.203-71.817-105.969-36.054-36.058-90.955-79.043-147.749-79.043-25.477 0-48.95 8.958-68.065 25.936-0.997 0.764-1.947 1.599-2.845 2.497l-110.135 110.132h-575.388c-16.032 0-29.031 12.998-29.031 29.031v827.374c0 16.032 12.998 29.031 29.031 29.031h827.374c16.032 0 29.031-12.998 29.031-29.031v-593.082c0-1.81-0.189-3.571-0.506-5.288l96.413-96.415c0.194-0.191 0.387-0.38 0.576-0.573 0.005-0.002 0.010-0.007 0.015-0.012l1.889-1.892c0.893-0.893 1.71-1.824 2.46-2.799 26.401-29.614 32.889-67.552 18.746-109.895zM395.108 786.044l-204.828 59.116 46.509-217.434 158.318 158.318zM448.213 757.035l-187.155-187.155 436.656-436.663 187.158 187.158-436.658 436.661zM833.209 965.939h-769.312v-769.312h488.301l-353.392 353.394c-3.96 3.96-6.692 8.98-7.862 14.457l-67.578 315.942c-2.136 9.979 1.13 20.348 8.595 27.308 5.448 5.076 12.546 7.795 19.799 7.795 1.551 0 560.096 0 560.096 0 16.037 0 29.031-12.998 29.031-29.031s-12.994-29.031-29.031-29.031h-354.821l95.237-27.487c4.715-1.362 9.007-3.895 12.478-7.364l368.458-368.458v511.787zM947.853 257.286c-0.317 0.339-0.624 0.685-0.922 1.035l-0.208 0.206c-0.099 0.099-0.203 0.198-0.302 0.298l-20.493 20.491-187.158-187.155 20.965-20.965c0.363-0.307 0.723-0.624 1.072-0.956 8.893-8.308 18.584-12.178 30.492-12.178 28.382 0 67.276 22.61 106.695 62.038 21.594 21.589 89.005 95.29 49.86 137.186z" fill="rgb(61, 104, 137)" stroke="inherit" stroke-width="inherit" stroke-linejoin="inherit" stroke-linecap="inherit" stroke-miterlimit="inherit" opacity="1">
																			</path>
																		</g>
																		<g ng-show="pref.showGrid" className="edit-grid ng-hide">
																			<g className="hLines"></g>
																			<g className="vLines"></g>
																		</g>
																	</svg>
																</button>
															</div>
															{Selected_Add_on_list.map((obj, index) => {
																return (
																	<>
																		<div className="mb-1">
																			<span className="badge badge-light-info me-2">{obj.Add_on_feature}</span>
																			<span className="fw-semibold text-gray-600">{subscription[0].currency == "USD" ? <>$</> : <>Rs. </>}{obj.price} X {obj.quantity}</span>
																		</div>
																	</>
																)
															})}
														</div>
													</>
												}
											</div>
											<div className="card-footer">
												<div class="d-flex flex-stack bg-success rounded-3 p-4 mb-2">
													<div class="fs-3 fw-bold text-white">
														<span class="d-block lh-1">Total</span>
													</div>
													<div class="fs-3 fw-bold text-white text-end">
														<span class="d-block lh-1" data-kt-pos-element="grant-total">{subscription[0].currency == "USD" ? <>$ </> : <>Rs. </>} {discounted_price}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</>
							:
							<>
								{state == 2 ?
									<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
									:
									<>
										{state == 0 &&
											<div className="flex-lg-row-fluid me-lg-15">
												<div className="card card-flush pt-3 mb-5 mb-lg-10">
													<div className="card-header">
														<div className="card-title">
															<h2 className="fw-bolder">Subscription Details</h2>
														</div>
													</div>
													<div className="card-body pt-0">
														<div className="text-gray-500 fw-bold fs-5 mb-5">Looks like there is some error</div>
														<div className="d-flex align-items-center p-3 mb-2">
														</div>
														<div className="notice d-flex bg-light-primary rounded border-primary border border-dashed rounded-3 p-6">
															<div className="d-flex flex-stack flex-grow-1">
																<div className="fw-bold">
																	<h4 className="text-gray-800 fw-bolder">No Subscription Available.</h4>
																	<div className="fs-6 text-gray-600">
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>}
									</>
								}
							</>
						}
					</div>
				</div>
			</div>

			<Modal show={discountModalShow} onHide={() => { setDiscountModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>Enter Coupon Information</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setDiscountModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="d-flex flex-column mb-5 fv-row">
							<div className="col-md-10 fv-row">
								<label className=" fs-5 fw-bold mb-2">Coupon Code</label>
								<div className="d-flex">
									<input type="text" className="form-control" value={coupon_code} onChange={(e) => {
										setcoupon_code(e.target.value);
									}}
										placeholder="ENTER A COUPON" name="coupon_code" id="coupon_code" />
									<button type="submit" className="btn btn-primary btn-sm rounded" onClick={(e) => { checkCouponAvailability(e) }} id="kt_careers_submit_button"
										data-kt-indicator={mainSubmitButtonState ? "on" : "off"}
										disabled={mainSubmitButtonState}
									>APPLY</button>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-secondary" onClick={() => { setDiscountModalShow(false) }}>Close</button>
					{/* {write == 1 && <form >
                        <button type="button" onClick={(e) => { submitStatus(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Update</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>} */}
				</Modal.Footer>
			</Modal>

			<Modal show={addressModalShow} onHide={() => { setAddressModalShow() }} size="md" centered>
				<Modal.Header>
					<Modal.Title>{address_id == "" ? <>Add New</> : <>Update</>} Address</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setAddressModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className="form-group row">
						<div className="row mb-5">
							<div className="col-md-6 fv-row">
								<label className="required form-label">Full Name</label>
								<input type="text" className="form-control" placeholder="" name="mobileno" id="mobileno" value={name} onChange={(e) => { setname(e.target.value) }} />
							</div>
							<div className="col-md-6 fv-row">
								<label className="required form-label">Mobile No</label>
								<input type="text" className="form-control" placeholder="" name="mobileno" id="mobileno" value={phone} onChange={(e) => { setphone(e.target.value) }} />
							</div>
						</div>
						<div className="d-flex flex-column flex-md-row gap-5">
							<div className="fv-row flex-row-fluid fv-plugins-icon-container">

								<label className="required form-label">Address Line 1</label>

								<input className="form-control" name="billing_order_address_1" placeholder="Address Line 1" value={address_line1} onChange={(e) => { setaddress_line1(e.target.value) }} />
								<div className="fv-plugins-message-container invalid-feedback"></div></div>
							<div className="flex-row-fluid">
								<label className="form-label">Address Line 2</label>
								<input className="form-control" name="billing_order_address_2" placeholder="Address Line 2" value={address_line2} onChange={(e) => { setaddress_line2(e.target.value) }} />
							</div>
						</div>

						<div className="d-flex flex-column flex-md-row gap-5">
							<div className="flex-row-fluid">
								<label className="form-label">City</label>
								<input className="form-control" name="billing_order_city" placeholder="" value={city} onChange={(e) => { setcity(e.target.value) }} />
							</div>
							<div className="fv-row flex-row-fluid fv-plugins-icon-container">
								<label className="required form-label">Postcode</label>
								<input className="form-control" name="billing_order_postcode" placeholder="" value={pincode} onChange={(e) => { setpincode(e.target.value) }} />
								<div className="fv-plugins-message-container invalid-feedback"></div></div>
							<div className="fv-row flex-row-fluid fv-plugins-icon-container">
								<label className="form-label">GstIn</label>
								<input type="text" className="form-control" placeholder="" name="last-name" id="GstIn" value={GstIn} onChange={(e) => { setGstIn(e.target.value) }} />
								<div className="fv-plugins-message-container invalid-feedback"></div></div>
						</div>
						<div className="row mb-5">
							<div className="col-md-6 fv-row">

								<label className="required form-label">Country</label>

								<div className="form-floating border rounded" data-select2-id="select2-data-360-ehcv">

									<label for="kt_ecommerce_edit_order_billing_country">Select a country</label>
								</div>
								<Select
									name="country"
									id="country"
									options={country_array}
									value={
										country_array.filter(option =>
											option.value == country)[0]
									}
									onChange={(e) => { loadState(e); }}
								/>
								<div className="fv-plugins-message-container invalid-feedback"></div></div>
							<div className="col-md-6 fv-row">
								<label className="required form-label">State</label>
								<div className="form-floating border rounded" data-select2-id="select2-data-360-ehcv">
									<label for="kt_ecommerce_edit_order_billing_country">Select state</label>
								</div>
								<Select
									name="state"
									id="state"
									options={state_array}
									value={
										state_array.filter(option =>
											option.value == state1)[0]
									}
									onChange={(e) => { setstate1(e.value); }}
								/>
								<div className="fv-plugins-message-container invalid-feedback"></div></div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-secondary" onClick={() => { setAddressModalShow(false) }}>Cancel</button>

					<button type="button" onClick={(e) => { update_billing_address(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} >
						<span className="indicator-label">{address_id == "" ? <>Submit</> : <>Update</>}</span>
						<span className="indicator-progress">Please wait...
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>

				</Modal.Footer>
			</Modal>

			<Modal show={WalletModalShow} onHide={() => { setWalletModalShow() }} size="lg" centered>
				<Modal.Header>
					<Modal.Title>Payment From E-Wallet</Modal.Title>
					<div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setWalletModalShow(false) }}>
						<span className="svg-icon svg-icon-1">
							<svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
								<g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
									<rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
									<rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
								</g>
							</svg>
						</span>
					</div>
				</Modal.Header>
				<Modal.Body>
					<div className='container'>
						<div className=" me-n7 pe-7">
							<div className="fv-row mb-10 fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
								<div className="row">
									<div className="col"><div className="card card-dashed flex-center min-w-175px my-3 p-6"><span className="fs-4 fw-semibold text-success pb-1 px-2">E-Wallet  Balance</span><span className="fs-lg-2tx fw-bold d-flex justify-content-center">{(organization_currency!==null && organization_currency.currency_code== "USD") ? "$" : <>Rs.</>}<span className="counted">{WalletAmount}</span></span></div></div>
									{(Number(WalletAmount ) - Number(discounted_price)) >= 0 &&
										<div className="col"><div className="card card-dashed flex-center min-w-175px my-3 p-6"><span className="fs-4 fw-semibold text-info pb-1 px-2">Need to pay</span><span className="fs-lg-2tx fw-bold d-flex justify-content-center">{(organization_currency!==null && organization_currency.currency_code== "USD") ? "$" : <>Rs.</>}<span className="counted">{Number(discounted_price)}</span></span></div></div>
									}
									{((WalletAmount) - Number(discounted_price)) < 0 &&
										<div className="col"><div className="card card-dashed flex-center min-w-175px my-3 p-6"><span className="fs-4 fw-semibold text-danger pb-1 px-2">Need More</span><span className="fs-lg-2tx fw-bold d-flex justify-content-center">{(organization_currency!==null && organization_currency.currency_code== "USD") ? "$" : <>Rs.</>}<span className="counted">{(Number(discounted_price) - Math.round(WalletAmount * 100) / 100)}</span></span></div></div>
									}
								</div>
							</div>

							{((WalletAmount ) - Number(discounted_price)) >= 0 ?
								<div className="notice d-flex bg-light-success rounded border-success border border-dashed mb-3 p-6">
									<span className="svg-icon svg-icon-2tx svg-icon-success me-4">
										<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
											<circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
											<rect fill="#000000" x="11" y="7" width="2" height="8" rx="1" />
											<rect fill="#000000" x="11" y="16" width="2" height="2" rx="1" />
										</svg>
									</span>
									<div className="d-flex flex-stack flex-grow-1">
										<div className="fw-bold">
											<h4 className="text-gray-800 fw-bolder">You can complete your payment.</h4>
											<div className="fs-6 text-gray-600"></div>
										</div>
									</div>
								</div>
								:
								<div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-3 p-6">
									<span className="svg-icon svg-icon-2tx svg-icon-warning me-4">
										<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
											<circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10" />
											<rect fill="#000000" x="11" y="7" width="2" height="8" rx="1" />
											<rect fill="#000000" x="11" y="16" width="2" height="2" rx="1" />
										</svg>
									</span>
									<div className="d-flex flex-stack flex-grow-1">
										<div className="fw-bold">
											<h4 className="text-gray-800 fw-bolder">Less Balance</h4>
											<div className="fs-6 text-gray-600">You can add Your balance during activate subscription.Click confirm if you want to continue it.</div>
										</div>
									</div>
								</div>
							}
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					{/* <button type="button" onClick={(e) => { window.location.reload(); }} className="btn btn-primary"> */}
					<button
						onClick={purchase_plan_wallet} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}>
						<span className="indicator-label">Confirm</span>
						<span className="indicator-progress">Please wait...
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
					</button>
				</Modal.Footer>
			</Modal>
		</>
	);
}
export default SubscriptionDeatails;